import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { apply as applyTheme, watchTheme } from './theme';
import './index.css';

// `index.html` 이 이미 한 번 붙였다. 여기서 다시 부르는 것은 두 곳이
// 어긋나지 않게 하기 위해서다 — 저장 열쇠를 고칠 때 한쪽만 고치면 여기서 걸린다.
// 목록에 없는 이름이 저장돼 있으면 이 호출이 기본값으로 되돌린다.
applyTheme();
watchTheme();

const root = document.getElementById('root');
if (!root) throw new Error('#root 가 없다');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
